/**
 * Simple event emitter for proxy errors.
 * Allows decoupled components to react to proxy/API errors.
 */

type ProxyErrorListener = (error: Error, context?: string) => void

const listeners: Set<ProxyErrorListener> = new Set()

/**
 * Emit a proxy error to all listeners.
 * Call this when a proxy API call fails.
 */
export function emitProxyError(error: Error, context?: string): void {
  console.error(`[Proxy Error${context ? ` - ${context}` : ''}]:`, error)
  for (const listener of listeners) {
    try {
      listener(error, context)
    }
    catch (e) {
      console.error('Error in proxy error listener:', e)
    }
  }
}

/**
 * Subscribe to proxy errors.
 * Returns an unsubscribe function.
 */
export function onProxyError(listener: ProxyErrorListener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

/**
 * Clear all listeners (useful for cleanup/testing).
 */
export function clearProxyErrorListeners(): void {
  listeners.clear()
}
